import React, { Component } from 'react';
import Footer from '../partials/Footer';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';

export default class PracticeResponse extends Component {

	constructor(props) {
		super(props);

		this.state = {
			date: Common.getUserData("appFullDate", true),
			appImgAlt: Config.appImgAlt,
			score_id: this.props.params.score_id,
			fst_name : '',
			cre_date : '',
			pr_name : '',
			comment : '',
			score : '',
			rej_reason : '',
			rej_date : '',
			reason : '',
			comm : '',
			datas : [],
		};

		this.getTr = this.getTr.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	getTr(val){
		this.setState({
			reason : val,
		})
	}

	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		})
	}

	onSubmit(){
		let reason=this.state.comm;
		let page_flag= '';
	    let practiceCorner = Common.getUserData("practiceCorner", true);
	    let practiceCornerMini = Common.getUserData("practiceCornerMini", true);
	    //alert(practiceCorner+'--'+practiceCornerMini);
	    if(practiceCorner != false){
	       page_flag = 1;
	    } else if(practiceCornerMini != false){
	       page_flag = 2;
	    } else{

	    }
		fetch(Config.domainUrl +"practice/practice-reject", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization':'Bearer ' +Common.getTokenData()
			},
			body: JSON.stringify({
				reason : reason,
				score_id : this.state.score_id,
				page_flag : page_flag,
				datas : this.state.datas,
			})
		}).then((response) => response.json()).then((responseJson) => {
			Common.reactLoader("hide");
			if (responseJson.status == 0) {
				Common.message(responseJson.message, responseJson.errors, "error");
			} else {
				Common.message('Success', responseJson.message, "success");
				this.GetInfo();
			}
		});
	}


	GetInfo() {
		Common.reactLoader("show", "Please wait...");
		let score_id = (!this.state.score_id)?1:this.state.score_id;
		fetch(Config.domainUrl +"practice/practice-response", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization':'Bearer ' +Common.getTokenData()
			},
			body: JSON.stringify({
				score_id : score_id
			})
		}).then((response) => response.json()).then((responseJson) => {
			Common.reactLoader("hide");
			if (responseJson.status == 0) {
				Common.message(responseJson.message, responseJson.errors, "error");
			} else {
				this.setState({
					fst_name:responseJson.datas[0].name,
					cre_date : responseJson.datas[0].cre_date,
					pr_name : responseJson.datas[0].pr_name,
					comment : responseJson.datas[0].comment,
					score : responseJson.datas[0].score,
					rej_reason : responseJson.datas[0].rej_reason,
					rej_date : responseJson.datas[0].rej_date,
					datas : responseJson.datas,
				})
			}
		});
		
	}


	componentWillMount() {
		this.GetInfo();
	}

	componentDidMount() {
		document.body.className = "inner";
	}

	render() {

		let page_flag= '';
	    let practiceCorner = Common.getUserData("practiceCorner", true);
	    let practiceCornerMini = Common.getUserData("practiceCornerMini", true);
	    //alert(practiceCorner+'--'+practiceCornerMini);
	    if(practiceCorner != false){
	       page_flag = 1;
	    } else if(practiceCornerMini != false){
	       page_flag = 2;
	    } else{

	    }

		return (
		<div className="row">
				<header>
						<div className="logo"><img src={process.env.PUBLIC_URL +'/images/logo.png'} alt="" title={this.state.appImgAlt} border="0" /></div>
						<div className="top-links reg-page"><img src={process.env.PUBLIC_URL +'/images/calendar_icon.png'} alt="" title="" border="0" /><span>{this.state.date}</span></div>
				</header>
				<section className="maincontent emailpage">
				    <section id="contentsection" className="contentarea"  >
				        <div className="main-inner practice">
				          	<div className="border-box">
					            <div className="title-bg">
					              <h1><span>
					                <img src={process.env.PUBLIC_URL +"/images/img-lr1.png"} align="absmiddle" alt="" border="0"/></span>
					                Practice Counter Authentication
					               </h1>
					            </div>
					            <section id="semana-scroll-inner" className="scrollbar">
					              <section className="scrollbar">
					                <section className="track">
					                  <section className="thumb"></section>
					                </section>
					              </section>
					              <section className="viewport">
					                <section className="overview">
					                  <div className="inner-content">
					                    <div className="img-box1"><img border="0" alt="" src={process.env.PUBLIC_URL +"/images/img-practiceauth.jpg"}/></div>
					                    <div className="tabdiv">
					                      <p><strong>Practice Counter Authentication</strong> - 
					                        <span className="red-txt">{this.state.cre_date}</span></p>
					                        <table width="100%" id='myTable' cellspacing="0" cellpadding="0" border="1" >
					                        	<tbody>
						                        	{(page_flag == 2)?
						                          		<tr>
	    				                              		<td width='42%'>Name </td>
	    				                              		<td ><strong>{this.state.fst_name}</strong></td>
	 													</tr>:
	 													<tr>
	    				                              		<td width='42%'>CL ite </td>
	    				                              		<td ><strong>{this.state.fst_name}</strong></td>
	 													</tr>
	 												}
 													<tr>
 														<td>Practice</td>
 														<td><strong>{this.state.pr_name}</strong></td>
 													</tr>
 													<tr>
 														<td>Report as per learner </td>
 														<td><strong>{this.state.comment}</strong></td>
 													</tr>
 													{(this.state.score != 0)?
						                          		<tr className="befresubmitted">
	    				                              		<td width='42%'></td>
	    				                              		<td ><a href="javascript:void(0);" onClick={(e)=>this.getTr('gettr')}>click here to reject the report</a></td>
	 													</tr>:
	 													<tr>
	    				                              		<td width='42%'>Rejected Reason </td>
	    				                              		<td ><strong>{this.state.rej_reason}</strong></td>
	 													</tr>
	 												}
	 												{(this.state.score != 0)?
						                          		'':
	 													<tr>
	    				                              		<td width='42%'>Rejected on </td>
	    				                              		<td ><strong>{this.state.rej_date}</strong></td>
	 													</tr>
	 												}
	 												{(this.state.reason!='')?
	 													<tr className="befresubmitted" id="gettr"> 
	    				                              		<td width='42%'>Rejected for Rejection </td>
	    				                              		<td ><textarea name='comm' id="comment" value={this.state.comm} onChange={(e)=>this.handleChange(e)}></textarea><input type="button" name='submit' value="submit" onClick={(e)=>this.onSubmit(e)}/> </td>
	 													</tr>: 
	 													''
	 												}
 												</tbody>	
					                        </table>
					                    </div>
					                  </div>
					                </section>
					              </section>
					            </section>
				          	</div>
				        </div>
				    </section>
				</section>
				<Footer />
		</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/practice/PracticeResponse.js